import makeEntities from './makeEntities';
import makeRoot from './makeRoot';

export default function make(src) {
  const out = makeRoot(src);
  out.entities = makeEntities(src);
  return out;
}
